<template>
  <el-dialog
    :visible.sync="isShow"
    width="600px"
    top="9vh"
    :title="isEdit? '编辑球员': '添加球员'"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <el-form
      ref="playerInfo"
      :model="playerInfo"
      :rules="formRules"
      label-width="120px"
      class="demo-ruleForm">
      <vue-scroll :ops="ops">
        <template v-if="userRole === 'coach'">
           <el-row>
            <el-col :span="20">
              <el-form-item  label="选择球队" prop="squadUuid" >
                <el-select
                  v-model.trim="playerInfo.coachSquadUuid"
                  style="width: 100%"
                  no-data-text="请选择球队"
                  :placeholder="$t('teamPlaceholder')"
                  @change="changeSquadForCoach(playerInfo.coachSquadUuid)">
                 <el-option
                          v-for="item in selectsquadList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.key"
                        >
                        </el-option>

                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-row v-if="!isEdit">
            <el-col :span="20">
              <el-form-item label="管理单位" prop="organUuid">
                <el-select
                  v-model.trim="playerInfo.organUuid"
                  style="width: 100%"
                  placeholder="请选择管理单位"
                  @change="changeOrg">
                  <el-option
                    v-for="item in organList"
                    :key="item.organUuid"
                    :value="item.organUuid"
                    :label="item.organShortName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="20">
              <el-form-item label="管理单位" prop="organUuid">
                <p style="padding-left: 12px">{{playerInfo.organShortName}}</p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="!isEdit">
            <el-col :span="20">
              <el-form-item label="单位" prop="youthUuid">
                <el-select
                  v-model.trim="playerInfo.youthUuid"
                  :disabled="isEdit"
                  style="width: 100%"
                  placeholder="请选择管理单位后再选择单位"
                  @change="changeCenter">
                  <el-option
                    v-for="item in centerList"
                    :key="item.uuid"
                    :value="item.uuid"
                    :label="item.youthShortName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="20">
              <el-form-item label="单位" prop="youthUuid">
                <p style="padding-left: 12px">{{playerInfo.youthShortName}}</p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item  label="选择球队" prop="squadUuid" >
                <el-select
                  v-model.trim="playerInfo.squadUuid"
                  style="width: 100%"
                  no-data-text="暂时没有球队，请前往球队管理添加球队"
                  :placeholder="$t('teamPlaceholder')"
                  @change="changeSquad">
                  <el-option
                    v-for="(item, index) in squadList"
                    :key="index"
                    :label="item.shortName"
                    :value="item.uuid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <el-row>
          <el-col :span="20">
            <el-form-item  label="姓名" prop="idName"  >
              <el-input v-model.trim="playerInfo.idName" placeholder="请输入球员姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item  label="身份证号" prop="idNumber"   >
              <el-input v-model.trim="playerInfo.idNumber" :disabled="isEdit ? true : false" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--<el-row>-->
          <!--<el-col :span="20">-->
            <!--<el-form-item label="手机号码" prop="phone">-->
              <!--<el-input v-model.trim="playerInfo.phone" placeholder="请输入球员手机号码"></el-input>-->
            <!--</el-form-item>-->
          <!--</el-col>-->
        <!--</el-row>-->
        <el-row>
          <el-col :span="20">
            <el-form-item  label="位置" prop="position">
              <el-select
                v-model.trim="playerInfo.position"
                multiple
                style="width: 100%"
                :placeholder="$t('positionPlaceholder')"
                @change="changePosition">
                <el-option
                  v-for="(item, index) in playerOption"
                  :key="index"
                  :label="item.playerPositionName"
                  :value="item.playerPositionName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="球衣号码" prop="playerNumber">
              <el-input v-model.number="playerInfo.playerNumber" placeholder="请输入球衣号码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item  label="上传照片">
          <UploadImg  :imgUrl.sync="playerInfo.headImgUrl" :avatarUrl.sync="img" />
          <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
        </el-form-item>
      </vue-scroll>
    </el-form>
    <!--<div v-if="!isEdit" class="tip">* 该手机号将作为球员的初始密码，身份证号作为登录帐号</div>-->
    <div class="dialog_btn_wrap">
      <el-button type="primary" :loading="addBtnLoading" @click="addPlayerAccount">确定</el-button>
      <el-button type="danger" style="margin-left: 20px" @click="isShow = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import player from '@/api/player'
import squad from '@/api/squad'
import rulesMixin from '@/utils/formRules/player'
import person from '@/assets/images/common/person.jpg'
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
// import { JSEncrypt } from 'jsencrypt'
import JSEncrypt from '@/assets/js/jsencrypt.min.js'
import auth from '@/api/auth'
export default {
  name: 'index',
  components: {
    'UploadImg': () => import('@/components/UploadImg')
  },
  mixins: [rulesMixin],
  props: {
    addPlayer: {
      type: Boolean,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    player: {
      type: Object,
      required: false
    },
    defaultSelect: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      ops,
      person,
      img: '',
      playerInfo: {
        coachSquadUuid: '',
        organUuid: '',
        organShortName: '',
        youthShortName: '',
        youthUuid: '',
        idName: '',
        // phone: '',
        idNumber: '',
        headImgUrl: '',
        playerNumber: '',
        positionId: '',
        squadUuid: '',
        squadShortName: '',
        position: []
      },
      playerOption: [],
      addBtnLoading: false,
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      organList: [],
      centerList: [],
      squadList: [],
      selectsquadList: [],
    }
  },
  computed: {
    isShow: {
      get () {
        return this.addPlayer
      },
      set (val) {
        this.$emit('update:addPlayer', val)
      }
    }
  },
  created () {
    if (this.isEdit) {
      this.formRules.idNumberPass = this.player.idNumber
      this.formRules.userUuid = this.player.uuid
      let { position, positionId } = this.player;
      position = position.split(',')
      positionId = positionId.split(',')
      if ('headImgUrl' in this.player) {
        this.playerInfo = Object.assign({}, this.player, { password: '', confirmPassword: '', position, positionId })
      } else {
        this.playerInfo = Object.assign({}, this.player, { password: '', confirmPassword: '', headImgUrl: '', position, positionId })
      }
    }
    this.getAllPositionList()
    if(this.userRole !== 'coach') {
      this.getOrganListAndCenterList()
    } else {
      this.getSquadList();
    }
  },
  methods: {
     getSquadList() {
      const _ = require('lodash');
      squad.getSquadListCoachAll().then(res => {
        if(res.code) {
          this.$message.error(res.msg)
          return
        }
        const uni_selectYouthList = _.unionBy(res, "squadUuid");
        this.selectsquadList = uni_selectYouthList.map((item) => ({
          label: `${item.organShortName} - ${item.youthShortName} - ${ item.shortName }`,
          value: item.squadUuid,
          key: JSON.stringify({
            squadUuid: item.squadUuid,
            youthUuid: item.youthUuid,
            organUuid: item.organUuid,
            organShortName: item.organShortName,
            youthShortName: item.youthShortName,
            shortName: item.shortName
            })
        }));

        // if(this.isEdit) {
        //   this.setPlayerInfoInEditForCoach()
        // }
      }).catch(err => {
        console.error('err', err)
      })
    },
    getAllPositionList () {
      player.allPositionList().then(res => {
        this.playerOption = res
      })
    },
    getOrganListAndCenterList () {
      let data = this.uuid
      let request
      if (this.userRole === 'organ') {
        request = squad.getOrgListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = squad.getOrgListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = squad.getOrgListByYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = squad.getOrgListByCoachOrLeader
      }
      request(data).then((res) => {
        this.organList = res
        if (this.organList.length === 1) {
          this.playerInfo.organUuid = res[0].organUuid
          this.playerInfo.organShortName = res[0].organShortName
          this.centerList = res[0].youthList || []
          if (this.centerList.length === 1) {
            this.playerInfo.youthUuid = this.centerList[0].uuid
            this.playerInfo.youthShortName = this.centerList[0].youthShortName
            this.squadList = this.centerList.find(item => {
              return item.uuid === this.playerInfo.youthUuid
            }).squadList || []
            if (this.squadList.length === 1) {
              this.playerInfo.squadUuid = this.squadList[0].uuid
              this.playerInfo.squadShortName = this.squadList[0].shortName
            }
          }
        }
        if (this.isEdit) {
          if (this.centerList.length < 1) {
            this.centerList = this.organList.find(item => {
              return item.organUuid === this.playerInfo.organUuid
            }).youthList || []
          }
          if (this.squadList.length < 1) {
            this.squadList = this.centerList.find(item => {
              return item.uuid === this.playerInfo.youthUuid
            }).squadList || []
          }
        }
        if (this.defaultSelect) {
          this.playerInfo.organUuid = this.defaultSelect.organUuid
          this.changeOrg()
          this.playerInfo.youthUuid = this.defaultSelect.youthUuid
        }
        if (this.defaultSelect) {
          this.changeCenter()
          this.playerInfo.squadUuid = this.defaultSelect.squadUuid
        }
      })
    },
    changeOrg () {
      this.centerList = []
      this.squadList = []
      this.playerInfo.squadUuid = ''
      this.playerInfo.squadShortName = ''
      this.playerInfo.youthUuid = ''
      this.playerInfo.youthShortName = ''
      if (this.playerInfo.organUuid) {
        this.playerInfo.organShortName = this.organList.find(item => {
          return item.organUuid === this.playerInfo.organUuid
        }).organShortName
        this.centerList = this.organList.find(item => {
          return item.organUuid === this.playerInfo.organUuid
        }).youthList || []
        if (this.centerList.length === 1) {
          this.playerInfo.youthUuid = this.centerList[0].uuid
          this.playerInfo.youthShortName = this.centerList[0].youthShortName
          this.squadList = this.centerList.find(item => {
            return item.uuid === this.playerInfo.youthUuid
          }).squadList || []
          if (this.squadList.length === 1) {
            this.playerInfo.squadUuid = this.squadList[0].uuid
            this.playerInfo.squadShortName = this.squadList[0].shortName
          }
        }
      }
    },
    changeCenter () {
      this.squadList = []
      this.playerInfo.squadUuid = ''
      this.playerInfo.squadShortName = ''
      if (this.playerInfo.youthUuid) {
        this.playerInfo.youthShortName = this.centerList.find(item => {
          return item.uuid === this.playerInfo.youthUuid
        }).youthShortName
        this.squadList = this.centerList.find(item => {
          return item.uuid === this.playerInfo.youthUuid
        }).squadList || []
        if (this.squadList.length === 1) {
          this.playerInfo.squadUuid = this.squadList[0].uuid
          this.playerInfo.squadShortName = this.squadList[0].shortName
        }
      }
    },
    changeSquad () {
      if (this.playerInfo.squadUuid) {
        this.playerInfo.squadShortName = this.squadList.find(item => {
          return item.uuid === this.playerInfo.squadUuid
        }).shortName || ''
      }
    },
    changeSquadForCoach( val) {
      if(val) {
        const { organShortName, organUuid, shortName, squadUuid, youthShortName, youthUuid } = JSON.parse(val);
        this.playerInfo.organShortName = organShortName
        this.playerInfo.organUuid = organUuid
        this.playerInfo.shortName = shortName
        this.playerInfo.squadUuid = squadUuid
        this.playerInfo.youthShortName = youthShortName
        this.playerInfo.youthUuid = youthUuid
      }
    },
    addPlayerAccount () {
      this.$refs['playerInfo'].validate(async vali => {
        if (vali) {
          this.addBtnLoading = true
          let requestName = player.addPlayer
          const alonePlayer = {
            position: this.playerInfo.position.join(','),
            positionId: this.playerInfo.positionId.join(','),
            organUuid: this.playerInfo.organUuid,
            organShortName: this.playerInfo.organShortName,
            squadUuid: this.playerInfo.squadUuid,
            youthUuid: this.playerInfo.youthUuid,
            youthShortName: this.playerInfo.youthShortName,
            shortName: this.playerInfo.squadShortName,
            playerNumber: this.playerInfo.playerNumber,
          }
          let requestData = {
            player: {
              // position: this.playerInfo.position.join(','),
              // positionId: this.playerInfo.positionId.join(','),
              // playerNumber: this.playerInfo.playerNumber,
              // organUuid: this.playerInfo.organUuid,
              // organShortName: this.playerInfo.organShortName,
              // squadUuid: this.playerInfo.squadUuid,
              // youthUuid: this.playerInfo.youthUuid,
              // youthShortName: this.playerInfo.youthShortName,
              // shortName: this.playerInfo.squadShortName,
              position: '',
              organUuid: '',
              organShortName: '',
              squadUuid: '',
              youthUuid: '',
              youthShortName: '',
              shortName: '',
            },
            playerToSquads: [alonePlayer],
            userForm: {
              idName: this.playerInfo.idName,
              idNumber: this.playerInfo.idNumber,
              // phone: this.playerInfo.phone,
              headImgUrl: this.playerInfo.headImgUrl
            }
          }
          if (this.isEdit) {
            requestName = player.updatePlayer
            requestData.player.uuid = this.playerInfo.uuid
            if (this.playerInfo.password) {
              let username = this.coachInfo.idNumber
              // // ras 加密
              let publicKey = await auth.getPublicKey(username)
              let encryptor = new JSEncrypt()
              encryptor.setPublicKey(publicKey)
              let rsaPassword = encryptor.encrypt(this.coachInfo.password)
              requestData.userForm.password = rsaPassword
            }
          }
          requestName(requestData).then(res => {
            this.addBtnLoading = false
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideDialog', false)
            }
          }).catch(err => {
            this.addBtnLoading = false
            console.error(err)
          })
        }
      })
    },
    changePosition (val) {
      if( val.length ){
        // let choseLisr = this.playerOption.filter(item => {
        //   return val.includes(item.playerPositionName)
        // })
        // let idArr = [];
        // choseLisr.forEach(item => {
        //   idArr.push(item.id)
        // })
        // this.$set(this.playerInfo, 'positionId', idArr.join(','))
        let arr = [];
        val.forEach(item => {
          this.playerOption.some(positionInfo => {
            if(item === positionInfo.playerPositionName) {
              arr.push(positionInfo.id)
            }
          })
        })
        this.$set(this.playerInfo, 'positionId', arr)
      } else {
        this.$set(this.playerInfo, 'positionId', [])
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .demo-ruleForm
    height 500px
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>
